import { createProduct, editProduct } from '../../_services/product.service';
import { getCompany } from '../../_utils/storage_handler';
import { 
    buildCreateProductBody,
    cleanInputs,
    validateCreateProduct 
} from './create_product.input';

export const createProductEvent = async () => {
    let body = buildCreateProductBody(getCompany());
    validateCreateProduct(body);
    let res = await createProduct(body);
    if(res.ok){
        cleanInputs();
    } else {
        throw new Error(res.error);
    }
    
    return res;
}

export const editProductEvent = async (id) => {
    let body = buildCreateProductBody(getCompany());
    validateCreateProduct(body);
    let res = await editProduct(body, id);
    if(! res.ok){
        throw new Error(res.error);
    }
    
    return res;
}